import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import {
    STATUS_FIND,
    STATUS_FIND_SUCCESS,
    STATUS_UPDATE_LOADING,
    STATUS_FAILURE,
} from '@store/actions';

import { StatusService } from '@core/services';
import { Status } from '@core/models';

@Injectable()
export class StatusEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private statusService: StatusService
  ) {}

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(STATUS_FIND),
      mergeMap(() => {
        this.store.dispatch(STATUS_UPDATE_LOADING({  loading: true }));

        return this.statusService.getStates().pipe(
          mergeMap(({ data }) => {
            const statusList = data as Status[];

            return [
              STATUS_FIND_SUCCESS({ statusList }),
              STATUS_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) => of(STATUS_FAILURE({ error })))
        )
      }),
    )
  );
}
